<template>
  <div class="custom-page">
    <div class="custom-page-bg">
      <div class="custom-page-card">
        <div class="custom-page-title">测评信息｜Evaluation Information</div>
        <div class="avatar">
          <div class="avatar-box"><img class="img" src="../assets/images/avatar.png" alt=""></div>
          <div class="nickname">{{ username }}</div>
        </div>
        <div class="text">
          <div class="cn">您的正确率为<span class="p1">{{ rate }}%</span></div>
          <div class="en">Your accuracy rate is</div>
        </div>
        <div class="text">
          <div class="cn">已经超过了全国<span class="p2">{{ rankRate }}%</span>的spellers</div>
          <div class="en">You have surpassed {{ rankRate }}% of the spellers in China.</div>
        </div>
        <div>
          <div class="flex">
            <div class="label">累积单词</div>
            <div class="progress"><div class="inner" :style="'width:' + ( totalAnswerNum ? '100%' : '0')"></div></div>
            <div class="count">{{ totalAnswerNum }}</div>
          </div>
          <div class="flex">
            <div class="label">正确次数</div>
            <div class="progress"><div class="inner" :style="'width: '+ succAnswerNumRate +'%;'"></div></div>
            <div class="count">{{ succAnswerNum }}</div>
          </div>
          <div class="flex">
            <div class="label">错误次数</div>
            <div class="progress"><div class="inner" :style="'width: '+ errAnswerNumRate +'%;'"></div></div>
            <div class="count">{{ errAnswerNum }}</div>
          </div>
        </div>
      </div>
      <div class="custom-page-card">
        <div class="custom-page-title">蜂竞技｜Bee Competition</div>
        <div>
          <div class="flex">
            <div class="label">参与场次</div>
            <div class="progress"><div class="inner" :style="'width:' + ( total_match_count ? '100%' : '0')"></div></div>
            <div class="count">{{ total_match_count }}</div>
          </div>
          <div class="flex">
            <div class="label">优胜次数</div>
            <div class="progress"><div class="inner" :style="'width: '+ yes_match_count_rate +'%;'"></div></div>
            <div class="count">{{ yes_match_count }}</div>
          </div>
        </div>
      </div>
      <div class="custom-page-card">
        <div class="custom-page-title">蜂计划｜Bee Plan</div>
        <div>
          <div class="flex">
            <div class="label">打卡次数</div>
            <div class="progress"><div class="inner" :style="'width:' + ( punchNum ? '100%' : '0')"></div></div>
            <div class="count">{{ punchNum }}</div>
          </div>
          <div class="flex">
            <div class="label">连打天数</div>
            <div class="progress"><div class="inner" :style="'width:' + ( punchDays ? '100%' : '0')"></div></div>
            <div class="count">{{ punchDays }}</div>
          </div>
          <div class="flex">
            <div class="label">正确单词</div>
            <div class="progress"><div class="inner" :style="'width:' + ( punchWordSuccNum ? '100%' : '0')"></div></div>
            <div class="count">{{ punchWordSuccNum }}</div>
          </div>
          <div class="flex">
            <div class="label">已掌握</div>
            <div class="progress"><div class="inner" :style="'width:' + ( masterNum ? '100%' : '0')"></div></div>
            <div class="count">{{ masterNum }}</div>
          </div>
          <div class="flex">
            <div class="label">未掌握</div>
            <div class="progress"><div class="inner" :style="'width:' + ( noMasterNum ? '100%' : '0')"></div></div>
            <div class="count">{{ noMasterNum }}</div>
          </div>
        </div>
      </div>
      <div class="btn-area">
        <div class="share" v-if="from === 'app'"
          v-clipboard:copy="content"
          v-clipboard:success="firstCopySuccess"
          v-clipboard:error="firstCopyError"
        >分享<div class="en">Share</div></div>
        <div class="btn" v-if="from === 'h5'" @click="openApp">打开拼词之星</div>
      </div>
    </div>
    <div class="mask" v-if="showMask">
      <img class="arrow" src="../assets/images/arrow.png" alt="">
      <div class="tip">请在浏览器中打开此链接</div>
    </div>
  </div>
</template>
 
<script>
export default {
  data () {
    return {
      androidDownloadUrl: '',
      showMask: false,
      username: '',

      rate: 0, // 正确率
      rankRate: 0, // 排名百分比
      totalAnswerNum: 0, // 累积单词
      succAnswerNum: 0, // 正确次数
      errAnswerNum: 0, // 错误次数

      succAnswerNumRate: 0,
      errAnswerNumRate: 0,

      total_match_count: 0, // 参与场次
      yes_match_count: 0, // 优胜次数

      yes_match_count_rate: 0,

      punchNum: 0, // 打卡次数
      punchDays: 0, // 连打天数
      punchWordSuccNum: 0, // 正确单词
      masterNum: 0, // 已掌握
      noMasterNum: 0, // 未掌握

      content: '',
      from: '' // h5/app
    }
  },
  mounted() {
    const token = this.$route.query.t
    localStorage.setItem('TOKEN', token)

    this.content = `http://page.fengyongtech.com/#/results?f=h5&t=${token} 这是我在拼词之星的战绩，快来看看吧！`
    this.from = this.$route.query.f
    this.getAppInfo()
    this.getpageInfo()
  },
  methods: {
    getpageInfo () {
      this.$http.get('/testreport/ajax_test_report_info').then(res => {
        if (res.code === 200) {
          this.username = res.data.user_info.username
          if (res.data.bee_plan_info) {
            this.rate = res.data.bee_plan_info.rate
            this.rankRate = res.data.bee_plan_info.rankRate

            this.totalAnswerNum = res.data.bee_plan_info.totalAnswerNum
            this.succAnswerNum = res.data.bee_plan_info.succAnswerNum
            this.errAnswerNum = res.data.bee_plan_info.errAnswerNum

            this.succAnswerNumRate = res.data.bee_plan_info.totalAnswerNum ? ( res.data.bee_plan_info.succAnswerNum / res.data.bee_plan_info.totalAnswerNum ) * 100 : 0
            this.errAnswerNumRate = res.data.bee_plan_info.totalAnswerNum ? ( res.data.bee_plan_info.errAnswerNum / res.data.bee_plan_info.totalAnswerNum ) * 100 : 0

            this.punchNum = res.data.bee_plan_info.punchNum
            this.punchDays = res.data.bee_plan_info.punchDays
            this.punchWordSuccNum = res.data.bee_plan_info.punchWordSuccNum
            this.masterNum = res.data.bee_plan_info.masterNum
            this.noMasterNum = res.data.bee_plan_info.noMasterNum
          }
          this.total_match_count = res.data.bee_jingji_info.total_match_count
          this.yes_match_count = res.data.bee_jingji_info.yes_match_count

          this.yes_match_count_rate = this.totalAnswerNum ? (this.yes_match_count / this.totalAnswerNum) * 100 : 0

          

        }
      })
    },
    firstCopySuccess(res) {
      console.log(res)
      this.$toast("已复制，快去分享吧～");
    },
    firstCopyError() {
      this.$toast("复制失败");
    },
    getAppInfo () {
      this.$http.get('/config/ajax_app_info').then(res => {
        if (res.code === 200) {
          this.androidDownloadUrl = res.data.android_url
        }
      })
    },
    openApp() {
      //是否是微信浏览器
      if (/(micromessenger)/i.test(navigator.userAgent)) { 
      //是否电脑微信或者微信开发者工具
        if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
          console.log('电脑微信或者微信开发者工具')
        }else{
          //手机微信打开的浏览器
          console.log('手机微信')
          this.showMask = true
        }
      } else {
        console.log('其他浏览器')
        const CONFIG = {
          iosScheme: "pczx://pages/tabbar/home/index", // iOS 应用 URL
          iosDownload: "https://apps.apple.com/cn/app/%E6%8B%BC%E8%AF%8D%E4%B9%8B%E6%98%9F/id6504004311", // iOS 下载页面 URL
          androidScheme: "pczx://pages/tabbar/home/index", // Android 应用 URL
          androidDownload: this.androidDownloadUrl, //Android 下载页面 URL
        };
        const userAgent = navigator.userAgent;
        const iframe = document.createElement("iframe");
        iframe.style.display = "none"; // 确保 iframe 不会显示在页面上
        // const startTime = new Date().getTime();
        this.hasApp = true; // 假设设备上已安装应用
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁止背景点击
          message: '请稍后...'
        })
        if (/iPhone|iPod|iPad/i.test(userAgent)) {
          this.timer = setTimeout(() => {
            // const endTime = new Date().getTime();
            // if (endTime - startTime < 2000) {
              this.hasApp = false;
              window.location.href = CONFIG.iosDownload; // 跳转到 iOS 下载页面的 URL
            // }
            document.body.removeChild(iframe);
          }, 3000);
          iframe.src = CONFIG.iosScheme; // 尝试打开 iOS 应用的 URL
          window.location.href = CONFIG.iosScheme
        } else if (/android/i.test(userAgent)) {
          this.timer = setTimeout(() => {
            // const endTime = new Date().getTime();
            // if (endTime - startTime < 2000) {
              this.hasApp = false;
              window.location.href = CONFIG.androidDownload; // 跳转到 Android 下载页面的 URL
            // }
            document.body.removeChild(iframe);
          }, 3000);
          iframe.src = CONFIG.androidScheme; // 尝试打开 Android 应用的 URL
          window.location.href = CONFIG.androidScheme
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.flex{
  display: flex;
  align-items: center;
  margin: 14px 0;
  .label{
    width: 58px;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    text-align: right;
    margin-right: 10px;
  }
  .progress{
    flex: 1;
    .inner{
      width: 100%;
      height: 12px;
      border-radius: 12px;
      background: linear-gradient(to bottom, #ffd16b, #fff497);
      
    }
  }
  .count{
    width: 40px;
    text-align: right;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
  }
}
.btn{
  background: linear-gradient(to bottom, #ffd16b, #fff497);
  box-shadow: 0 6px 0 0 #d9b059;
  width: 200px;
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  font-size: 16px;
  font-family: normal;
  color: #000;
  font-weight: 900;
  margin: 20px auto 0;
  text-align: center;
}
.mask{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,.75);
  z-index: 10000;
  font-size: 16px;
  .arrow{
    position: absolute;
    right: 30px;
    top: 10px;
    width: 100px;
  }
  .tip{
    color: #c89d41;
    font-size: 18px;
    text-align: center;
    width: 60%;
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    border-radius: 15px;
    position: absolute;
    top: 55px;
    left: 30px;
  }
}
.avatar{
  text-align: center;
  padding-top: 10px;
  .avatar-box{
    width: 60px;
    height: 60px;
    border-radius: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to top, #d9b059, #f5ea90);
    margin: 0 auto 8px;
  }
  .img{
    width: 50px;
    height: 50px;
    border-radius: 50px;
  }
  .nickname{
    font-size: 16px;
    font-weight: bold;
  }
}
.text{
  font-size: 20px;
  font-weight: bold;
  margin: 26px 0;
  .cn{
    line-height: 20px;
  }
  .en{
    font-size: 12px;
  }
}
.p1{
  color: #d9b059;
  font-size: 48px;
  font-weight: bold;
  position: relative;
  bottom: -14px;
  background-image: -webkit-linear-gradient(bottom, #f5ea90, #d9b059);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.p2{
  color: #d9b059;
  font-size: 30px;
  font-weight: bold;
  background-image: -webkit-linear-gradient(bottom, #f5ea90, #d9b059);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.btn-area{
  padding-bottom: 20px;
}
.share{
  width: 100px;
  height: 100px;
  background: url(../assets/images/share.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 20px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #000;
  font-size: 20px;
  font-weight: bold;
  .en{
    font-size: 14px;
  }
}
</style>